import { HttpErrorResponse } from '@angular/common/http';
import { Action, createReducer, on } from '@ngrx/store';

import {
  FinancialEntityNamesFailure,
  FinancialEntityNamesRequest,
  FinancialEntityNamesReset,
  FinancialEntityNamesSuccess,
} from './actions';
import { ParameterResult } from '@models/swagger';

export const featureKey = 'financialEntityNames';

export interface State {
  data: ParameterResult[] | null;
  error: HttpErrorResponse | null;
  loading: boolean;
}

export const initialState: State = {
  data: [],
  error: null,
  loading: null,
};

export function reducer(state: State | undefined, action: Action) {
  return createReducer(
    initialState,
    on(FinancialEntityNamesFailure, (state, { error }) => ({ ...state, data: [], error, loading: false })),
    on(FinancialEntityNamesRequest, state => ({ ...state, error: null, loading: true })),
    on(FinancialEntityNamesSuccess, (state, { data }) => ({ ...state, data, error: null, loading: false })),
    on(FinancialEntityNamesReset, state => ({ ...state, data: [], error: null, loading: false }))
  )(state, action);
}
